import axios from 'axios'
import React, { useEffect } from 'react'
import { useParams } from 'react-router'
import { DIGITAL_APP_BASE } from '../../../../constants/apiBase'

const TradeNameSynh = () => {
  const tradeNameParams = useParams()?.tradeName !== 'Acai' ? useParams()?.tradeName : 'OST6'
  useEffect(() => {
    const userData = localStorage.getItem('userData') ? JSON.parse(localStorage.getItem('userData')) : null
    const code = userData?.tradeNameCode
    const invalid =
      code == null ||
      code === '' ||
      code === 'undefined' ||
      code === 'null'
    if (invalid) {
      localStorage.setItem('userData', JSON.stringify({...userData, tradeNameCode: null }))
    }
  }, [])

  useEffect(() => {
    const invalidParam =
      tradeNameParams == null ||
      tradeNameParams === '' ||
      tradeNameParams === 'undefined' ||
      tradeNameParams === 'null'
    if (tradeNameParams !== undefined && !invalidParam) {
      const tradeId = async () => { 
        const responseLogin = await axios.get(`${DIGITAL_APP_BASE}/api/contacts/client-by-trade-name?tradeName=${tradeNameParams}`)
        console.log(responseLogin.data);
        const localStorageData = localStorage.getItem('userData') ? JSON.parse(localStorage.getItem('userData')) : null
        console.log(localStorageData);
        console.log(localStorage.getItem('userData'))
        const resolvedTradeName =
          responseLogin.data?.tradeName &&
          responseLogin.data.tradeName !== 'null' &&
          responseLogin.data.tradeName !== 'undefined'
            ? responseLogin.data.tradeName
            : tradeNameParams
        if (localStorageData?.employee && tradeNameParams == 'TPOITD') {
          localStorage.setItem('userData', JSON.stringify({
            ...localStorageData,
            tradeNameCode: resolvedTradeName,
            tradeNameAdress: responseLogin.data?.name,
            employee: resolvedTradeName == 'TPOITD' ? true : false,
          }))
        } else {
          if (localStorageData?.employee && tradeNameParams!== 'TPOITD') {
            console.log('')
          } else {
            localStorage.setItem('userData', JSON.stringify({
              ...localStorageData,
              tradeNameCode: resolvedTradeName,
              tradeNameAdress: responseLogin.data?.name,
            }))
          }
        }
      }
      tradeId()
    }
  }, [tradeNameParams])
}

export default TradeNameSynh